// src/ecrans/useAncienEcran.js — L'ANCIEN ÉCRAN, ouvert depuis le nouveau
// (P-4.24) tant que les portes d'écriture n'existent pas : aucun geste n'est
// retiré à l'admin (bloquer, confier, créer, cocher…).
//
// Il se REFERME à chaque changement d'onglet : revenir sur une zone rouvre
// toujours le nouvel écran.

import { useCallback, useEffect, useState } from "react";

export function useAncienEcran(tab) {
  const [ancien, setAncien] = useState(null);
  useEffect(() => {
    setAncien(null);
  }, [tab]);
  const ouvert = useCallback((t) => ancien === t && tab === t, [ancien, tab]);
  const ouvrir = useCallback((t) => setAncien(t), []);
  const fermer = useCallback(() => setAncien(null), []);
  return { ouvert, ouvrir, fermer };
}
